// Founding Member badge rules shared by every screen that shows a badge.
// The stored description holds a "{city}" placeholder that must never reach
// the screen raw.

export const FOUNDING_MEMBER_SLUG = "founding_member";

/** Badges invisible until earned. Only Founding Member, by slug. */
export function isHiddenUntilEarned(slug: string | null | undefined): boolean {
  return slug === FOUNDING_MEMBER_SLUG;
}

/** Fill "{city}" with the earned city, or a neutral phrase when unknown. */
export function formatBadgeDescription(
  description: string | null | undefined,
  city?: string | null,
): string {
  const text = description ?? "";
  const filled = city && city.trim() ? city.trim() : "your city";
  return text.split("{city}").join(filled);
}
